import { RootState } from '../types'

export const getUser = (state: RootState) => (state.user as any).details
export const getBranch = (state: RootState) => (state.user as any).branchDetails
export const getAuthenticated = (state: RootState) => (state.user as any).isAuthenticated
export const getAccessToken = (state: RootState) => (state.user as any).accessToken
// export const getMappedAcc = (state: RootState) => (state.user as any).mappedAccount
// export const getFirstLoginStatus = (state: RootState) => (state.user as any).fisrtLoginCheck
